var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.96 5.16992C17.96 6.55992 19.34 8.76992 19.62 11.3199",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48999 11.3697C2.74999 8.82973 4.10999 6.61973 6.08999 5.21973",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18994 19.9404C8.34994 20.5304 9.66994 20.8604 11.0599 20.8604C12.3999 20.8604 13.6599 20.5604 14.7899 20.0104",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.06 6.69965C12.5954 6.69965 13.84 5.455 13.84 3.91965C13.84 2.3843 12.5954 1.13965 11.06 1.13965C9.52468 1.13965 8.28003 2.3843 8.28003 3.91965C8.28003 5.455 9.52468 6.69965 11.06 6.69965Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83005 18.9204C5.3654 18.9204 6.61005 17.6757 6.61005 16.1404C6.61005 14.605 5.3654 13.3604 3.83005 13.3604C2.2947 13.3604 1.05005 14.605 1.05005 16.1404C1.05005 17.6757 2.2947 18.9204 3.83005 18.9204Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.17 18.9204C19.7054 18.9204 20.95 17.6757 20.95 16.1404C20.95 14.605 19.7054 13.3604 18.17 13.3604C16.6347 13.3604 15.39 14.605 15.39 16.1404C15.39 17.6757 16.6347 18.9204 18.17 18.9204Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.d12702d4c361d625a1e9eb18deefd18c.svg";
export { ForwardRef as ReactComponent };